import React from "react";
import "./stats.css";

const stats = [
  { value: "3+", label: "Years of Professional Experience" },
  { value: "8", label: "Commercial Games Delivered" },
  { value: "6", label: "Commercial Client Projects" },
  { value: "2", label: "Steam Games in Production" },
  { value: "10", label: "Largest Team Managed" },
  { value: "2", label: "Unity Interns Mentored" },
  { value: "4.9★", label: "Google Play Rating" },
  { value: "1,500+", label: "Dread Manor Downloads" },
  { value: "Top 250", label: "Brackeys Game Jam · 2300+ teams" },
];

const Stats = () => {
  return (
    <section id="highlights">
      <h5>By The Numbers</h5>
      <h2>Quick Facts</h2>
      <div className="container stats__container">
        {stats.map(({ value, label }) => (
          <article className="stat__card" key={label}>
            <span className="stat__value">{value}</span>
            <span className="stat__label">{label}</span>
          </article>
        ))}
      </div>
    </section>
  );
};

export default Stats;
